import React from 'react';
import { Users2, Image as ImageIcon, UserPlus, BookHeart } from 'lucide-react';

const POINTS = [
  {
    icon: Users2,
    title: 'Every relationship in one place',
    desc: 'Parents, partners, in-laws, step-family, blended households — all welcome.',
  },
  {
    icon: ImageIcon,
    title: 'Memories that travel with you',
    desc: 'Photos, videos and stories tied to the people they belong to.',
  },
  {
    icon: UserPlus,
    title: 'Built together, by your family',
    desc: 'Invite anyone you love — your network grows as everyone adds their branch.',
  },
  {
    icon: BookHeart,
    title: 'A private space that lasts',
    desc: 'Your family story, preserved for the generations still to come.',
  },
];

const TrustStrip: React.FC = () => {
  return (
    <section className="bg-gradient-to-b from-white to-pink-50/40 py-20 sm:py-24">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <div className="text-xs uppercase tracking-[0.2em] text-fuchsia-600 font-semibold mb-3">
            A living family network
          </div>
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-slate-900 leading-tight">
            Reconnect. Remember. Grow Together.
          </h2>
          <p className="mt-5 text-lg text-slate-600 leading-relaxed">
            KinsCircle is a private family operating system — connecting blood
            relatives, spouses, partners, in-laws, step-family and the people
            who matter most, across every household and generation.
          </p>
        </div>


        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {POINTS.map((p) => (
            <div
              key={p.title}
              className="group bg-white rounded-2xl p-6 border border-slate-100 shadow-sm hover:shadow-lg hover:-translate-y-1 transition-all duration-300"
            >
              <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-fuchsia-100 to-pink-100 flex items-center justify-center mb-4 group-hover:from-fuchsia-500 group-hover:to-purple-600 transition-colors">
                <p.icon className="w-6 h-6 text-fuchsia-600 group-hover:text-white transition-colors" />
              </div>
              <div className="font-serif text-lg font-semibold text-slate-900 mb-1.5 leading-snug">
                {p.title}
              </div>
              <div className="text-sm text-slate-500 leading-relaxed">{p.desc}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustStrip;
